export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_18-EN-e7d254939ac589cdae227b17a885b42b.webp";